import styled from '@emotion/styled'
import Breakpoint from '../../Breakpoint'

export const ExternalLink = styled.a`
    display: flex;
    align-items: center;
    text-decoration: none;
    color: black;
    font-weight: 500;
    padding: 8px 0;
    font-size: 2rem;
    transition: scale 0.4s;
    font-family: 'Roboto' !important;

    &.active {
        color: var(--primary-color);
        border-bottom: 2px solid var(--primary-color);
    }

    &:hover {
        color: var(--primary-color);
        scale: 1.05;
    }

    & * {
        margin-right: 8px;
        padding-left: 16px;

        @media (max-width: ${Breakpoint.PHONE}) {
            height: 3rem;
        }
    }

    &:active {
        transform: scale(0.95);
    }

    @media (max-width: ${Breakpoint.TABLET_L}) {
        justify-content: flex-start;
    }
`

export default ExternalLink
